import { Flex, Text, Card } from '@applyboard/crystal-ui';
import { ColorDot } from './ColorDot';
import { ReportsResult } from '../../context/ReportsResultContext';

type ChartLegendProps = {
  stats: ReportsResult['stats'];
  totalApplications: ReportsResult['totalApplications'];
};

export function ChartLegend(props: ChartLegendProps) {
  return (
    <>
      <Card aria-label="Total Applications">
        <Flex direction="column" gap={0} py={6} px={2}>
          <Text variant="labelL" contrast="low">
            TOTAL APPLICATIONS
          </Text>
          <Text variant="titleL">{props.totalApplications}</Text>
        </Flex>
      </Card>
      <Flex direction="column" pt={6} gap={6}>
        {props.stats.map((stat) => (
          <div aria-label={stat.title} key={stat.title}>
            <Flex justify="between">
              <Flex gap={2} align="center">
                <ColorDot color={stat.color} />
                <Text variant="labelL" contrast="low">
                  {stat.title.toUpperCase()}
                </Text>
              </Flex>
              <Text variant="labelL">{stat.value}</Text>
            </Flex>
          </div>
        ))}
      </Flex>
    </>
  );
}
